// @ts-nocheck: converted from JS

import Account from '@/components/Account';

export default Account;
